'use client';

import dynamic from 'next/dynamic';
import { useEffect, useState } from 'react';

import { PreviewStatus } from './preview-state';
import { installSameOriginXlsxWorkerAssets } from './xlsx-worker-origin';

const XlsxViewerPreview = dynamic(
  () => import('./extend-ui/ui/xlsx-viewer').then((module) => module.XlsxViewerPreview),
  {
    loading: () => <PreviewStatus>Loading spreadsheet preview...</PreviewStatus>,
    ssr: false,
  },
);

function useSameOriginXlsxWorkerAssets() {
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    const uninstall = installSameOriginXlsxWorkerAssets();
    setIsReady(true);

    return uninstall;
  }, []);

  return isReady;
}

export function XlsxArtifactPreview({ sourceUrl, title }: { sourceUrl: string; title: string }) {
  const isWorkerAssetRewriteReady = useSameOriginXlsxWorkerAssets();

  if (!isWorkerAssetRewriteReady) {
    return <PreviewStatus>Loading spreadsheet preview...</PreviewStatus>;
  }

  return (
    <XlsxViewerPreview
      className="h-full min-h-[480px]"
      fileName={title}
      isDark={false}
      onIsDarkChange={() => undefined}
      showDownload={false}
      showToolbar={false}
      showUpload={false}
      src={sourceUrl}
    />
  );
}
